import { AppEntities } from "../../../../config/entities";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { NewDocumentListView } from "../../../Shared/NewDocumentListView";

const ExchangeDifferenceCalculationsList = () => {
    const fields: IListViewField[] = [
    ];

    return (
        <>
            <NewDocumentListView fields={fields} entity={AppEntities.ExchangeDifferenceCalculations} />
        </>
    );
}

export default ExchangeDifferenceCalculationsList;